import { FeedbackListComponent } from './components/feedback-list/feedback-list.component';
import { ChangeDetectorRef } from '@angular/core';
import {
    addNavMenuItem,
    ModalService,
    registerBulkAction,
    DataService,
    NotificationService,
    addNavMenuSection,
    getServerLocation,
} from '@vendure/admin-ui/core';
import { DeleteFeedbacksDocument, GetFeedbacksDocument } from './generated-types';
import { deleteFeedbackDealsBulkAction } from './components/feedback-deals-list/feedback-deals-list-bulk-actions';

export default [
    addNavMenuSection(
        {
            id: 'feedbacks',
            label: 'Feedbacks',
            requiresPermission: 'FeedbackControl',
            items: [
                {
                    id: 'feedbacks',
                    label: 'Feedbacks',
                    routerLink: ['/extensions/feedbacks/list'],
                    icon: 'event',
                },
                {
                    id: 'feedback-deals',
                    label: 'Feedbacks Deals',
                    routerLink: ['/extensions/feedbacks/deals'],
                    icon: 'eye',
                },
            ],
        },
        'customers',
    ),
    registerBulkAction(deleteFeedbackDealsBulkAction),
    registerBulkAction({
        location: 'feedback-list',
        label: 'Delete',
        icon: 'trash',
        requiresPermission: 'SuperAdmin',
        iconClass: 'is-danger',

        onClick: async ({ injector, selection, clearSelection }) => {
            const modalService = injector.get(ModalService);
            const dataService = injector.get(DataService);
            const notificationService = injector.get(NotificationService);
            const cdr = injector.get(ChangeDetectorRef);
            const component = injector.get(FeedbackListComponent);

            const selectedIds = selection.map(item => item.id); // Get selected IDs

            if (selectedIds.length === 0) {
                return;
            }

            modalService
                .dialog({
                    title: 'Confirm  Delete',
                    body: `Are you sure you want to delete ${selectedIds.length} feedback items?`,
                    buttons: [
                        { type: 'danger', label: 'Delete', returnValue: true },
                        { type: 'secondary', label: 'Cancel' },
                    ],
                })
                .subscribe(async confirmed => {
                    if (confirmed) {
                        dataService
                            .mutate(DeleteFeedbacksDocument, { ids: selectedIds })
                            .subscribe(async () => {
                                notificationService.success('Deleted Successfully');
                                clearSelection();

                                dataService.query(GetFeedbacksDocument).ref.refetch();
                                component.refresh();
                                cdr.detectChanges();
                            });
                    }
                });
        },
    }),

    registerBulkAction({
        location: 'feedback-list',
        label: 'Export CSV',
        icon: 'download',
        requiresPermission: 'FeedbackControl',
        iconClass: 'is-info',

        onClick: async ({ injector, selection }) => {
            const modalService = injector.get(ModalService);

            const selectedIds = selection.map(item => item.id); // Get selected IDs

            if (selectedIds.length === 0) {
                return;
            }

            modalService
                .dialog({
                    title: 'Export CSV',
                    body: `Are you sure you want to export ${selectedIds.length} feedbacks?`,
                    buttons: [
                        { type: 'primary', label: 'Yes', returnValue: true },
                        { type: 'secondary', label: 'No' },
                    ],
                })
                .subscribe(async confirmed => {
                    if (confirmed) {
                        const res = await fetch(
                            `${getServerLocation()}/export-feedbacks/export?ids=${selectedIds.join(',')}`,
                        );
                        if (!res.ok) {
                            const json = await res.json();
                            throw Error(json?.message);
                        }
                        const header = res.headers.get('Content-Disposition');
                        const parts = header!.split(';');
                        const filename = parts[1].split('=')[1];
                        const blob = await res.blob();
                        await downloadBlob(blob, filename);
                    }
                });
        },
    }),
];

async function downloadBlob(blob: Blob, fileName: string) {
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('hidden', 'true');
    a.href = blobUrl;
    a.download = fileName;
    a.setAttribute('target', '_blank');
    a.click();
    document.body.removeChild(a);
}
